import CreditCardForm from './CreditCardForm';
import './CreditCardForm.css';

export default CreditCardForm;



// WEBPACK FOOTER //
// ./src/shared/components/CreditCardForm/index.js